<div *ngIf="!singleChannel && !singleChannelMultiPlay" class="video-block section-padding">
  <div class="row">
     <div class="col-md-12">
        <div class="row">
            <div *ngFor="let channel of allChannels.channel; let i=index;" class="col-xs-6 col-sm-3 col-6 mb-3">
                <div class="channels-card">
                    <div class="channels-card-image">
                        <a routerLink="/channel/{{channel.id}}/explore">
                            <img class="img-fluid" src={{channel.profilePicUrl}} alt="">
                        </a>
                        <div class="channels-card-image-btn">
                            <a routerLink="/channel/{{channel.id}}/explore"></a>
                        </div>
                    </div>
                    <div class="channels-card-body">
                        <div class="channels-title">
                            <a routerLink="/channel/{{channel.id}}/explore">{{channel.name}}</a>
                        </div>
                    </div>
                </div>
            </div>
      </div>
        </div>
     </div>
    </div>
    <div *ngIf="singleChannel && !singleChannelMultiPlay" class="video-block section-padding">
        <div class="row">
           <div class="col-md-12">
              <div class="row">
                <div *ngIf="!videosLoaded" class="video-block section-padding loadingBlock container-fluid">
                    <div id="loading"></div>
                      </div>
                  <div *ngIf="videosLoaded" class="video-block section-padding">
                          <div class="row">
                              <div *ngFor="let video of contents; let i=index;" class="col-6 playlist col-sm-3 mb-3">
                                  <div class="video-card">
                                      <div class="video-card-image" [class.educationImages]="isHeadStart">
                                          <a class="play-icon" routerLink="/play/{{video.currentContentView}}">
                                              <i class="fas fa-play-circle"></i>
                                          </a>
                                          <a routerLink="/play/{{video.currentContentView}}">
                                              <span *ngIf="video.contentImageUrl != null"><img *ngIf="!isHeadStart" class="img-fluid" src="{{video.contentImageUrl}}" alt=""><img *ngIf="isHeadStart" class="img-fluid" src="{{video.contentImagePortraitUrl}}" alt=""></span><span *ngIf="video.contentImageUrl == null"><img *ngIf="!isHeadStart"  class="img-fluid" src="https://s3.us-east-2.amazonaws.com/videyo-cdn/contentImages/defaults/content-default.png" alt=""><img *ngIf="isHeadStart"  class="img-fluid" src="https://s3.us-east-2.amazonaws.com/videyo-cdn/contentImages/defaults/headstart.jpg" alt=""></span><span *ngIf="video.contentImagePortraitUrl== null"><img *ngIf="isHeadStart"  class="img-fluid" src="https://s3.us-east-2.amazonaws.com/videyo-cdn/contentImages/defaults/headstart.jpg" alt=""></span>
                                          </a>
                                        
                                      </div>
                                      <div class="video-card-body">
                                          <div class="video-title">
                                              <a routerLink="/play/{{video.currentContentView}}">{{video.title}}</a>
          
                                          </div>
                                          <div class="video-page text-success">
                                              <a title="" data-placement="top" data-toggle="tooltip" routerLink="/play/{{video.currentContentView}}" data-original-title="Verified">
          
                                              </a>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
            </div>
              </div>
           </div>
          </div>
          <div *ngIf="singleChannelMultiPlay && !singleChannel" class="video-block section-padding">
            <div class="row">
               <div class="col-md-12">
                  <div class="row">
                    <div *ngIf="!videosLoaded" class="video-block section-padding loadingBlock container-fluid">
                        <div id="loading"></div>
                          </div>
                      <div *ngIf="videosLoaded" class="video-block section-padding">
                              <div class="row">
                                <div class="col-6 playlist col-sm-3 mb-3"  *ngFor="let playlist of playlists; let i=index;">
                                    <div class="channels-card">
                                            <div class="channels-card-image chanhomeimage">
                                               <a routerLink="/playlist/{{singleChannelID}}/{{playlist.id}}/videos"><img class="img-fluid" src="{{playlist.profileUrl}}" alt=""></a>
                                                </div>
                                            <div class="channels-card-body">
                                               <div class="channels-title">
                                                  <a routerLink="/playlist/{{singleChannelID}}/{{playlist.id}}/videos">{{playlist.name}}</a>
                                               </div>
                                            </div>
                                         </div>
                                            </div>
                              </div>
                          </div>
                </div>
                  </div>
               </div>
              </div>
